import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// "ResizeObserver loop completed with undelivered notifications" (Radix popover + cmdk) → bildirimleri bir sonraki kareye ertele
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(cb) { super((entries, obs) => window.requestAnimationFrame(() => cb(entries, obs))); }
  };
  window.addEventListener("error", (e) => {
    if (/ResizeObserver loop/.test(e.message || "")) { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
